import { createApp, defineComponent } from 'vue';
import GridTextCellEditor from './GridTextCellEditor.vue';
import globalToast from '$$vueCmp/toast';
import InlineEditors from '../../../controllers/inlineEditors';
import Tasks from '../../../controllers/tasks';
import keyboardNavigation from '../../keyboardNavigation';

export default function (instance) {
  let vueApp = null;
  let vueInstance = null;

  return {
    show(id, column, config, placeholder) {
      const ComponentBuilder = defineComponent(GridTextCellEditor);

      const task = instance.getTask(id);
      const taskNode = instance.getTaskRowNode(task.id);
      const isEditTask = task.type !== instance.config.types.button;
      const onSave = () => {
        keyboardNavigation.needMoveDownAfterSave = true;
        instance.ext.inlineEditors.save();
      };
      const onCancel = () => {
        instance.ext.inlineEditors.hide();
      };

      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = createApp(ComponentBuilder, {
        placeholder,
        taskNode,
        isEditTask,
        onSave,
        onCancel,
      });
      vueInstance = vueApp.mount(placeholder);
    },

    hide() {
      if (vueApp) {
        vueApp.unmount();
      }

      vueApp = null;
      vueInstance = null;
    },

    set_value(task, taskId, column, node) {
      if (task.type !== instance.config.types.button) {
        vueInstance.value = task.text;
      }
    },

    get_value(id, column, node) {
      return vueInstance.value;
    },

    is_changed(task, taskId, column, node) {
      if (task.type !== instance.config.types.button) {
        return task.text !== vueInstance.value;
      }

      return true;
    },

    is_valid(value, id, column, node) {
      const task = instance.getTask(id);

      if (task.type !== instance.config.types.button && !value?.trim()) {
        globalToast.warning(__('settings_msg_task_name_invalid'));

        return false;
      }

      return true;
    },

    save(id, column, node) {
      const task = instance.getTask(id);
      const taskName = vueInstance.value?.trim();

      if (task.type !== instance.config.types.button) {
        task.text = taskName;
        instance.updateTask(task.id);

        return;
      }

      const newTask = {
        parent: task.parent,
        type: InlineEditors.newTaskType,
        text: taskName || (InlineEditors.newTaskType === instance.config.types.milestone ? __('gantt_new_sibling_milestone') : __('gantt_new_sibling_task')),
        created_at: new Date(),
      };

      keyboardNavigation.creatingTask = true;
      InlineEditors.newTaskType = instance.config.types.task;
      Tasks.createTaskFromGridButton(newTask);
    },

    focus(node) {
    },
  };
}
